import useRevalidateFileDetail from '@/modules/FileDetail/hooks/useRevalidateFileDetail';
import { moveToInprogressActionMutationFn } from '@/modules/FileDetail/queries/sendActions/moveToInprogressAction/moveToInprogressActionMutationFn';
import { MoveToInprogressActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/moveToInprogressAction/moveToInprogressActionMutationFn.types';
import { useMutation } from '@tanstack/react-query';

const useMoveToInprogressActionMutation = (id: string) => {
  const { revalidateFileDetail } = useRevalidateFileDetail(id);

  return useMutation({
    mutationFn: (data: MoveToInprogressActionMutationDataType) =>
      moveToInprogressActionMutationFn(data, id),
    meta: {
      successToast: 'اقدام با موفقیت انجام شد',
    },
    onSuccess: () => {
      return revalidateFileDetail();
    },
  });
};

export default useMoveToInprogressActionMutation;
